
<app-nav></app-nav>
<div class="senior-citizen-insurance">
  <div class="row web-view" >
    <div class="breadcumb row"  style="display: flex; justify-content: center;">
      <ul>
        <li class="active">Age</li>
        <li>Quotes</li>
        <!-- <li>Proposal Form</li>
        <li>Payment</li> -->
      </ul>
    </div>
    <div class="row" style="width: 100%;">
        <div class="col-md-5 col-lg-5">
          <div class="label-1">
            Help Take
The Financial Burden Off 
Your Loved Ones
          </div>
          <div class="label-2">Family Health Senior Citizen Insurance</div>
            <div class="" style="margin-top: 6%; margin-left: 8%;">
              <!-- <ul style="text-decoration: none; margin-top: 8px;">
                <li><span class="right-icon"></span><span class="label-3">Premium Starts </span><span class="label-4">@₹25,499</span><span class="label-5">(Excluding Taxes)</span></li>
                <li><span class="right-icon"></span><span class="label-3">Sum Insured</span> <span class="label-4">₹3,00,000 / ₹5,00,000</span></li>
                <li><span class="right-icon"></span><span class="label-3">Age 51 to 75</span></li>
              </ul> -->
              <input type="text" name="age" inputmode=”numeric” class="form-control" placeholder="Enter eldest member age"
              value="{{seniorAge}}"   [(ngModel)]="seniorAge"  
              />
            </div>
            <div style="display:flex; justify-content:center" class="mt-2">
              <span style="font-size: 14px; color:red">{{errorMessage}}</span>
            </div>
            <div style="display:flex; justify-content:flex-start">
              <button class="btn Rectangle-1980 mt-3" (click)="redirectToProposalForm()">Next</button>
              <!-- <span style="margin-top: 2%; margin-left: 8%;">or</span>
              <button class="btn Rectangle-17">View Details</button> -->
            </div>
            <p class="trust">Trusted By</p>
            <div style="margin-top: 2%; margin-left: 8%;">
              <!-- Removing care asked by Rakhi  16th June-->
              <!-- <img src="https://securenow.in/static/images/Care_logo_DCA.webp"/> -->
              <img class="ml-3" src="../../assets/images/star.png"/>
            </div>
        </div>

        

        <div class="col-md-7 col-lg-7" style="display: flex; justify-content: flex-end;">
          <img class="img-class-fhi" src="https://static-files-website.s3.ap-south-1.amazonaws.com/image_2022_06_28T11_37_27_491Z.png">
        </div>
    </div>
    <div class="container"> 
      <div class="Insurance-Coverage-Details" style="width: 100%;">Insurance Coverage Details</div>
      <div class="row benefit-list" style="display: flex; margin-top: 3%;">
         <div *ngFor="let data of viewData" class="col-md-4 my-3">
           <div>
            <div class="row" class="benefit-box">
              <div class=""><div class="circle-plus">+</div></div>
              <div class="ml-2 p-2 benefit-box-data">{{data}}</div>
           </div>
           </div>
           
         </div>
      </div>
    </div>
    
</div>
   
    

  <div class="row mobile-view" >
    <div class="breadcumb row"  style="display: flex; justify-content: center;">
      <ul>
        <li class="active">Benefits</li>
        <!-- <li>Proposal Form</li>
        <li>Payment</li> -->
      </ul>
    </div>
    <div class="row">
      <div class="col-3"></div>
      <div class="col-9" style="display: flex; justify-content: flex-end;">
        <img class="img-class-fhi" src="https://static-files-website.s3.ap-south-1.amazonaws.com/image_2022_06_28T11_37_27_491Z.png">
      </div>
    </div>
    <div class="row">
      <div class="label-1 text-center">
        Help Take The Financial Burden Off Your Loved Ones
      </div>
    </div>
    <div class="row" style="margin:12px auto;width: 100%;">
    <div class="label-2 my-3 fw-bold" style="margin:0 auto">Family Health Senior Citizen Insurance</div>
      <!-- <div class="" style="margin-top: 6%; margin-left: 8%;">
        <ul style="text-decoration: none; margin-top: 8px;">
          <li><span class="right-icon"></span><span class="label-3">Premium Starts </span><span class="label-4">@₹25,499</span><span class="label-5">(Excluding Taxes)</span></li>
          <li><span class="right-icon"></span><span class="label-3">Sum Insured</span> <span class="label-4">₹3,00,000 / ₹5,00,000</span></li>
          <li><span class="right-icon"></span><span class="label-3">Age 51 to 75</span></li>
        </ul>
      </div>      -->
      <div class="text-center" style="margin:0 auto;width: 70%">
        <input type="text" name="age" inputmode=”numeric” class="form-control Rectangle-1988" placeholder="Enter eldest member age"
        value="{{seniorAge}}" style="padding: 12px;"  [(ngModel)]="seniorAge"  
        />
      </div>
    </div>
    <div style="display:flex; justify-content:center" class="mt-2">
      <span style="font-size: 14px; color:red">{{errorMessage}}</span>
    </div>
    <div class="container">
      <div style="display:flex; justify-content:center; width:100%">
        <button class="btn Rectangle-1981 "(click)="redirectToProposalForm()">Next</button>
        <!-- <span style="margin-top: 2%">or</span>
        <button class="btn Rectangle-17" style="margin-left: -1%;">View Details</button> -->
      </div>
    </div>
    <div class="container" >
      <p class="trust-mob" style="display: flex; justify-content: center;">Trusted By</p>
      <div  style="margin: 6%; display: flex; justify-content: center;">
        <!-- <img src="https://securenow.in/static/images/Care_logo_DCA.webp"/> -->
        <img class="ml-3" src="../../assets/images/star.png"/>
      </div>
    </div>
    <div class="Insurance-Coverage-Details mt-3 mb-2" style="width: 100%;">Insurance Coverage Details</div>
    <div class="container benefit-list mt-4 mb-3" style="display: flex; overflow-x:auto; margin-top: 3%;">
       <div *ngFor="let data of viewData" >
         <div class="container" class="benefit-box">
            <div class=""><div class="circle-plus">+</div></div>
            <div class="ml-2">{{data}}</div>
         </div>
       </div>
    </div>
    </div>



</div>